import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=4fb31cb6&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"
import style0 from "./phone.vue?vue&type=style&index=0&id=4fb31cb6&prod&scoped=true&lang=css"
import style3 from "./phone.vue?vue&type=style&index=3&id=4fb31cb6&prod&lang=css"
import style4 from "./phone.vue?vue&type=style&index=4&id=4fb31cb6&prod&scoped=true&lang=css"
import style5 from "./phone.vue?vue&type=style&index=5&id=4fb31cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb31cb6",
  null
  
)

export default component.exports